import { z } from "zod/mini"

export const IntegrationFieldLegacySchema = z.string()

export type IntegrationFieldLegacy = z.infer<typeof IntegrationFieldLegacySchema>
